
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import {
  FileStatusMessage,
  MeasurementSpecificationTemplate,
  MeasurementSpecificationTemplateMedia,
  MediaApiControllerUIClient,
  MediaItem,
} from '../../backend/backendapi';
import { emptyUUID } from '../../../util';
import { initClient } from '../../../api';
import { StatusMessage } from '../../dropzone/dropzone.util';
import DropZone from '../../dropzone/DropZone';
import Spinner from '../../util/Spinner.vue';

@Component({
  components: {
    DropZone,
    ImageViewer: require('../../imageviewer/imageviewer.vue.html').default,
    Spinner,
  },
})
export default class MeasurementSpecificationTemplateMedias extends Vue {
  @Prop({ default: true })
  readonly template!: MeasurementSpecificationTemplate;
  @Prop({ default: true })
  readonly editable!: boolean;

  private readonly mediaApi = initClient(MediaApiControllerUIClient);
  medias: MediaItem[] | null = null;

  get uid(): number {
    return (this as any)._uid;
  }

  onFileUploaded(status: FileStatusMessage): void {
    if (status.type === StatusMessage.success) {
      this.template.medias ??= [];
      this.template.medias.push(MeasurementSpecificationTemplateMedia.fromJS({ id: emptyUUID(), templateId: emptyUUID(), mediaId: status.fileId! }));
      this.reloadMedia();
    }
  }

  async reloadMedia(): Promise<void> {
    this.medias = null; //reset in case the following code fails to load the media
    const mediaIds = this.template.medias?.map(media => media.mediaId) ?? [];
    this.medias = await Promise.all(mediaIds.map(mediaId => this.mediaApi.get(mediaId)));
  }

  onMediaRemoved(mediaId: string): void {
    if (!this.template.medias) {
      return;
    }
    const index = this.template.medias.findIndex(e => e.mediaId === mediaId);
    if (index >= 0) {
      this.template.medias.splice(index, 1);
      this.reloadMedia();
    }
  }

  @Watch('template.id', { immediate: true })
  private onTemplateIdChanged(): void {
    this.reloadMedia();
  }
}
